import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { VERIFY_OTP_REQUEST } from '../../Utils/Constant';

const OtpVerification = ({ onBackToLogin, onVerified, email }) => {
  const dispatch = useDispatch();
  const { loading, error, verifyOtpSuccess } = useSelector(state => state.auth);

  const [otpDigits, setOtpDigits] = useState(['', '', '', '', '', '']);
  const inputRefs = useRef([]);

  useEffect(() => {
    inputRefs.current[0]?.focus();
  }, []);

  useEffect(() => {
    if (verifyOtpSuccess) {
      onVerified && onVerified(otpDigits);
    }
  }, [verifyOtpSuccess, otpDigits, onVerified]);

  const handleChange = (index, value) => {
    if (/^\d?$/.test(value)) {
      const newOtp = [...otpDigits];
      newOtp[index] = value;
      setOtpDigits(newOtp);

      // Move to next box
      if (value && index < 5) {
        inputRefs.current[index + 1]?.focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !otpDigits[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const otp = otpDigits.join('');
    if (otp.length === 6 && email) {
      dispatch({ type: VERIFY_OTP_REQUEST, payload: { email, otp } });
    }
  };

  return (
    <div
      className="min-vh-100 d-flex align-items-center justify-content-center"
      style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: '1rem',
      }}
    >
      <div
        className="card shadow-lg"
        style={{
          maxWidth: 420,
          width: '100%',
          borderRadius: '1rem',
          padding: '2rem',
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
        }}
      >
        <h2 className="card-title text-center mb-4 fw-bold" style={{ color: '#333' }}>
          OTP Verification
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4 text-center">
            <label className="form-label fw-semibold mb-2">Enter the 6-digit OTP</label>
            <div className="d-flex justify-content-between">
              {otpDigits.map((digit, index) => (
                <input
                  key={index}
                  type="text"
                  inputMode="numeric"
                  maxLength="1"
                  className="form-control text-center mx-1"
                  style={{
                    width: '2.5rem',
                    fontSize: '1.5rem',
                    borderRadius: '0.5rem',
                  }}
                  value={digit}
                  onChange={(e) => handleChange(index, e.target.value)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  ref={(el) => (inputRefs.current[index] = el)}
                  required
                />
              ))}
            </div>
          </div>

          {error && (
            <div className="alert alert-danger py-2 mb-4 text-center" style={{ fontWeight: '500', fontSize: '0.9rem' }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            className="btn w-100 py-2 fw-bold"
            disabled={loading}
            style={{
              fontSize: '1.1rem',
              borderRadius: '0.75rem',
              letterSpacing: '0.05em',
              backgroundColor: '#000',
              color: '#fff',
              boxShadow: '0 4px 15px rgba(0, 0, 0, 0.4)',
              transition: 'background-color 0.3s ease',
              border: 'none',
            }}
          >
            {loading ? 'Verifying...' : 'Verify OTP'}
          </button>
        </form>

        <div className="mt-4 text-center">
          <button
            className="btn btn-link text-decoration-none"
            onClick={onBackToLogin}
            type="button"
            style={{ fontWeight: '600', color: '#764ba2' }}
          >
            Back to Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default OtpVerification;
